import React from "react";
import LandingSection from "../components/utilities/LandingSection";
import MediaGallerySection from "../components/utilities/MediaGallerySection";
import IssuesSection from "../components/utilities/IssuesSection";
import ServicesShowcase from "../components/utilities/ServicesSection";
import AboutSection from "../components/utilities/AboutSection";
import LocationSection from "../components/utilities/LocationSection";
import UniqueValueSection from "../components/utilities/UniqueValueSection";
import TestimonialsSection from "../components/utilities/TestimonialSection";
import { Helmet } from "react-helmet";
// import WarReliefPopup from "../components/utilities/WarReliefPopup";


const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Greh Pravesh Therapy - Group of Expert Psychologists in India</title>

        <meta name="description" content="Looking for a psychologist in India? Greh Pravesh offers the right therapist both online & offline for depression, anxiety, PTSD etc. across the country. Call Now." />

        {/* Keywords using layman terms */}
        <meta name="keywords" content="mental health help, counseling, therapy near me, relationship counselor, family counseling, stress management, anxiety help, depression support, emotional wellness, mental health doctor, therapist consultation, online therapy, couples counseling, mental wellness, emotional support" />

        {/* Open Graph Tags for Social Media */}
        <meta property="og:title" content="Greh Pravesh Therapy - Group of Expert Psychologists in India" />
        <meta property="og:description" content="Looking for a psychologist in India? Greh Pravesh offers the right therapist both online & offline for depression, anxiety, PTSD etc. across the country. Call Now. " />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/images/help.png" />

        {/* Schema.org markup for Google */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "Greh Pravesh Therapy",
            "image": "/images/help.png",
            "@id": "GrehPraveshTherapy",
            "url": "https://grehpraveshtherapy.com",
            "telephone": "+918591049845",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "4/20",
              "addressLocality": "West Patel Nagar, ",
              "postalCode": "New Delhi-110008",
              "addressCountry": "IN"
            },
            "geo": {         // Add coordinates
              "@type": "GeoCoordinates",
              "latitude": "",
              "longitude": ""
            },
            "medicalSpecialty": [
              "Mental Health Therapy",
              "Relationship Counseling",
              "Family Therapy",
              "Professional Counseling"
            ],
            "availableService": [
              {
                "@type": "MedicalTherapy",
                "name": "Individual Therapy",
                "description": "One-on-one counseling for personal mental wellness"
              },
              {
                "@type": "MedicalTherapy",
                "name": "Couples Therapy",
                "description": "Relationship counseling for couples"
              },
              {
                "@type": "MedicalTherapy",
                "name": "Family Therapy",
                "description": "Counseling services for families"
              },
              {
                "@type": "MedicalTherapy",
                "name": "Professional Counseling",
                "description": "Mental health support for working professionals"
              }
            ],
            "openingHoursSpecification": {  // Add operating hours
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
              ],
              "opens": "09:00",
              "closes": "18:00"
            },

          })}
        </script>
      </Helmet>
      <LandingSection />
      <AboutSection />
      <UniqueValueSection />
      <ServicesShowcase />
      <IssuesSection />
      <TestimonialsSection />
      <MediaGallerySection />
      <LocationSection />
      
    </>

  )
}

export default Home;